<crm-activity-logger-association
  [associations]="associationsList()"
  [mobile]="mobile"
  [options]="(options$ | async) ?? []"
  [placeholder]="placeholder"
  (add)="handleAdd($event)"
  (remove)="handleRemove($event)"
  (searchTermChange)="handleSearchTermChange($event)"
></crm-activity-logger-association>
